module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-vod-15-years.3f150ba7.svg";